export default {
    'AUTH.CREATE_PASSWORD.TITLE': 'Create a password',
    'AUTH.CREATE_PASSWORD.TCS_APPROVE.TEXT': 'I read and accept',
    'AUTH.CREATE_PASSWORD.TCS_APPROVE.LINK_TEXT': 'Calizy\'s T&Cs',
    'AUTH.CREATE_PASSWORD.BUTTON': 'Sign up',
    'AUTH.CREATE_PASSWORD.HEADER': 'To access Calizy Pro, please create your password',
};
